import { ACTION } from './actions';
import { combineReducers } from 'redux';
import { locationArticlesReducer } from './container/locationDetail/reducers';
import { xhrRequestReducer } from './../ui/src/reducers';
import {
  transformTvKosiceVideoToStandardArticle,
  getProp,
} from './../ui/src/utilities.js';

const footermenu = (
  state = {
    isFetching: false,
    data: {
      sections: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.FOOTERMENU_REQUEST:
    case ACTION.FOOTERMENU_SUCCESS:
    case ACTION.FOOTERMENU_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('FOOTERMENU', state, action),
      );
    default:
      return state;
  }
};

const categories = (
  state = {
    isFetching: false,
    data: {
      sections: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.CATEGORIES_REQUEST:
    case ACTION.CATEGORIES_SUCCESS:
    case ACTION.CATEGORIES_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('CATEGORIES', state, action),
      );
    default:
      return state;
  }
};

const seasonmenu = (
  state = {
    isFetching: false,
    data: {
      sections: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.SEASONMENU_REQUEST:
    case ACTION.SEASONMENU_SUCCESS:
    case ACTION.SEASONMENU_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('SEASONMENU', state, action),
      );
    default:
      return state;
  }
};

const homeVasimiOcamiArticles = (
  state = {
    isFetching: false,
    data: {
      nextOffset: null,
      articles: [],
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'VASIMI_OCAMI';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const homeCategories = (
  state = {
    data: {
      sections: [],
    },
  },
  action,
) => {
  if (action.type === ACTION.HOME_CATEGORIES) {
    return Object.assign({}, state, {
      data: action.data,
    });
  } else {
    return state;
  }
};

const locationCategories = (
  state = {
    data: {
      sections: [],
    },
  },
  action,
) => {
  if (action.type === ACTION.LOCATION_CATEGORIES) {
    return Object.assign({}, state, {
      data: action.data,
    });
  } else {
    return state;
  }
};

const homeTopArticles = (
  state = {
    isFetching: false,
    data: {
      nextOffset: null,
      articles: [],
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'HOMEPAGE_TOP_ARTICLES';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const locationSmartTags = (
  state = {
    isFetching: false,
    data: {
      values: [],
      id: null,
      title: null,
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'LOCATION_SMART_TAGS';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const homeLocationArticles = (
  state = {
    data: {
      values: [],
    },
  },
  action,
) => {
  if (action.type === ACTION.HOME_LOCATION_ARTICLES) {
    return Object.assign({}, state, {
      data: action.data,
    });
  } else {
    return state;
  }
};

const playlist = (
  state = {
    isFetching: false,
    data: {
      items: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.PLAYLIST_REQUEST:
    case ACTION.PLAYLIST_SUCCESS:
    case ACTION.PLAYLIST_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('PLAYLIST', state, action),
      );
    default:
      return state;
  }
};

export const getSectionAndLocationKey = (sectionId, locationId = null) => {
  return `${sectionId}-${locationId}`;
};

const getKeyFromAction = (action) => {
  return getSectionAndLocationKey(action.sectionId, action.locationId);
};

const sectionDetailBySectionIdAndLocationIdReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTION.SECTION_DETAIL_REQUEST:
      return {
        ...state,
        [getKeyFromAction(action)]: {
          ...state[getKeyFromAction(action)],
          isFetching: true,
        },
      };
    case ACTION.SECTION_DETAIL_SUCCESS:
      return {
        ...state,
        [getKeyFromAction(action)]: {
          ...state[getKeyFromAction(action)],
          isFetching: false,
          articles: {
            articles:
              action.articleOffset === 0
                ? action.data.articles.articles
                : [
                    ...state[getKeyFromAction(action)].articles.articles,
                    ...action.data.articles.articles,
                  ],
            nextOffset: action.data.articles.nextOffset,
          },
          [action.data.locations ? 'locations' : undefined]: action.data
            .locations,
        },
      };
    default:
      return state;
  }
};

const sectionDetail = combineReducers({
  bySectionAndLocationId: sectionDetailBySectionIdAndLocationIdReducer,
});

const articleDetailByArticleIdReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTION.ARTICLE_DETAIL_REQUEST:
      return {
        ...state,
        [action.articleId]: {
          ...state[action.articleId],
          isFetching: true,
        },
      };
    case ACTION.ARTICLE_DETAIL_SUCCESS:
      return {
        ...state,
        [action.articleId]: {
          ...state[action.articleId],
          isFetching: false,
          articles: action.articles,
        },
      };
    default:
      return state;
  }
};

const articleDetail = combineReducers({
  byArticleId: articleDetailByArticleIdReducer,
});

const mostRead = (
  state = {
    isFetching: false,
    interval: {},
  },
  action,
) => {
  switch (action.type) {
    case ACTION.MOST_READ_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.MOST_READ_SUCCESS: {
      let interval;
      if (action.append) {
        interval = Object.assign({}, state.interval, {
          [action.data.interval]: {
            articles: [
              ...state.interval[action.data.interval].articles,
              ...action.data.articles.articles,
            ],
            nextOffset: action.data.articles.nextOffset,
          },
        });
      } else {
        interval = Object.assign({}, state.interval, {
          [action.data.interval]: action.data.articles,
        });
      }

      return Object.assign({}, state, {
        isFetching: false,
        interval,
      });
    }
    default:
      return state;
  }
};

const homeTvKosiceArticle = (
  state = {
    isFetching: false,
    data: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.HOME_TVKOSICE_ARTICLE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.HOME_TVKOSICE_ARTICLE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data.map((item) =>
          transformTvKosiceVideoToStandardArticle(item),
        ),
      });
    default:
      return state;
  }
};

const homeRadioKosiceArticle = (
  state = {
    isFetching: false,
    data: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.HOME_RADIOKOSICE_ARTICLE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.HOME_RADIOKOSICE_ARTICLE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data.map((item) => {
          return {
            _id: item._id,
            name: item.name,
            date: item.date,
            created: item.created,
            perex: getProp(item, 'perex'),
            picture: {
              uri: getProp(item, 'picture.uri', null),
            },
            section: {
              name: getProp(item, 'section.name', null),
            },
            url: item.url,
          };
        }),
      });
    default:
      return state;
  }
};

const weatherCredit = (
  state = {
    data: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.WEATHER_CREDIT:
      return Object.assign({}, state, {
        data: action.credit,
      });
    default:
      return state;
  }
};

const loggedUser = (
  state = {
    user: null,
    unreadArticles: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.GET_USER:
      return Object.assign({}, state, {
        user: action.data,
      });
    case ACTION.UPDATE_UNREAD_ARTICLES:
      return Object.assign({}, state, {
        unreadArticles: action.data,
      });
    default:
      return state;
  }
};

const calendar = (
  state = {
    locations: [],
    events: {
      isFetching: false,
      byKey: {},
    },
  },
  action,
) => {
  switch (action.type) {
    case ACTION.FETCH_CALENDAR_LOCATIONS_SUCCESS:
      return Object.assign({}, state, {
        locations: action.data,
      });
    case ACTION.UPDATE_UNREAD_ARTICLES:
      return Object.assign({}, state, {
        unreadArticles: action.data,
      });
    case ACTION.FETCH_CALENDAR_EVENTS_REQUEST:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: true,
        }),
      });
    case ACTION.FETCH_CALENDAR_EVENTS_FAILURE:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: false,
        }),
      });
    case ACTION.FETCH_CALENDAR_EVENTS_SUCCESS: {
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: false,
          byKey: Object.assign({}, state.events.byKey, {
            [action.data.key]: action.data.events,
          }),
        }),
      });
    }
    default:
      return state;
  }
};

const calendarStaticText = (
  state = {
    isFetching: false,
    data: {
      content: null,
      static_content: null,
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'CALENDAR_STATIC_TEXT';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const calendarStaticTextAdd = (
  state = {
    isFetching: false,
    data: {
      content: null,
      static_content: null,
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'CALENDAR_STATIC_TEXT_ADD';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const siteBanners = (
  state = {
    data: {},
  },
  action,
) => {
  switch (action.type) {
    case 'BANNER_FETCH_SUCCESS':
      return Object.assign({}, state, {
        data: Object.assign({}, state.data, {
          [action.data.id]: {
            data: action.data.data,
          },
        }),
      });
    default:
      return state;
  }
};

const electionReducer = (
  state = {
    slovakia: {
      data: {},
      isFetching: false,
    },
    region: {
      data: {},
      isFetching: false,
    },
    staticData: {
      data: {},
      isFetching: false,
    },
    district: {
      data: {},
      isFetching: false,
    },
    kosice: {
      data: {},
      isFetching: false,
    },
  },
  action,
) => {
  switch (action.type) {
    case ACTION.ELECTION_SLOVAKIA_REQUEST:
    case ACTION.ELECTION_SLOVAKIA_SUCCESS:
    case ACTION.ELECTION_SLOVAKIA_FAILURE: {
      const key = 'ELECTION_SLOVAKIA';
      return {
        ...state,
        slovakia: xhrRequestReducer(key, state.slovakia, action),
      };
    }

    case ACTION.ELECTION_STATIC_DATA_REQUEST:
    case ACTION.ELECTION_STATIC_DATA_SUCCESS:
    case ACTION.ELECTION_STATIC_DATA_FAILURE: {
      const key = 'ELECTION_STATIC_DATA';
      return {
        ...state,
        staticData: xhrRequestReducer(key, state.staticData, action),
      };
    }

    case ACTION.ELECTION_REGION_REQUEST:
    case ACTION.ELECTION_REGION_SUCCESS:
    case ACTION.ELECTION_REGION_FAILURE: {
      const key = 'ELECTION_REGION';
      return {
        ...state,
        region: xhrRequestReducer(key, state.region, action),
      };
    }

    case ACTION.ELECTION_DISTRICT_REQUEST:
    case ACTION.ELECTION_DISTRICT_SUCCESS:
    case ACTION.ELECTION_DISTRICT_FAILURE: {
      const key = 'ELECTION_DISTRICT';
      return {
        ...state,
        district: xhrRequestReducer(key, state.district, action),
      };
    }

    default:
      return state;
  }
};


export default {
  footermenu,
  categories,
  seasonmenu,
  homeVasimiOcamiArticles,
  homeCategories,
  locationCategories,
  homeTopArticles,
  locationSmartTags,
  homeLocationArticles,
  playlist,
  sectionDetail,
  articleDetail,
  mostRead,
  homeTvKosiceArticle,
  homeRadioKosiceArticle,
  weatherCredit,
  loggedUser,
  calendar,
  calendarStaticText,
  calendarStaticTextAdd,
  siteBanners,
  locationArticles: locationArticlesReducer,
  election: electionReducer,
  // authorArticles: authorArticlesReducer,
};



// WEBPACK FOOTER //
// ./src/app/reducers.js